/* 20230306: There was no header on this file as a work history so I am starting one now
 *            EVERY PROGRAMMER WILL KEEP THIS HEADER LOG UP TO DATE EVERY TIME THIS CODE IS CHANGED!
 * 20230306: XT - I am putting the Spanish translation code back into the front end that was lost or removed.
 *            The html changes for Spanish should be in THREE columns; incident, description & location description
 * 20230307: XT - found bug in the colors of font for the images and map if 0 images or map not set.
 *             the <div> HAS to be separated because they are in levels. Top level is BLACK and the onClick makes it blue/link
 * 20230801: xt - fixed the spanish translation to show for the MDT GO app
 *                and fixed the frontend to show the spanish translation for when the assigment col shows
 * 20250615: xt - several days working on this to update from react-bootstrap to bootstrap 5.3.3
 * 20250616: xt - got the Show Map working with new B5 and new map and no map icons
 * 20250617: xt - fixed ESLint error, added null checks, restored noDept structure
 * 20250625: xt - removed react-table (incompatible with React 18) and replaced with custom HTML table, kept if/else structure
 * 20250625: xt - fixed JSX error in tbody by correcting extra </td> in Location column
 * 20260819: xt - added the features for the Config and Stats tab
 * 20260819: xt - added the resolve column
 * 20260819: xt - match staging and prod as of now
 */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";
import { showModal } from "../../actions/modal";
import IncidentTimes from "../Incidents/IncidentTimes";
import IncidentResponder from "../Incidents/IncidentResponder";
import IncidentResolution from "../IncidentResolution/IncidentResolution";
import IncidentAction from "../Incidents/IncidentAction";
import "./ReportSummaries.css";

const ReportSummaries = ({
  summaries,
  agency,
  languageCode,
  dispatch,
  profile,
  rowPerPage,
  curPage,
  updateRowPerPage,
  updateCurPage,
  totalPages,
}) => {
  // console.log('Summaries data:', JSON.stringify(summaries, null, 2));
  // console.log('Summaries length:', summaries?.length);
  // console.log('First summary example:', summaries?.[0] || 'No data');
  // console.log('dispatch:', dispatch);
  // console.log('agency:', agency);
  console.log('profile:', profile);
  console.log('summaries.length is:', summaries.length);
  console.log('rowPerPage ', rowPerPage);
  console.log('total pages is ', totalPages);

  const [resolutionOverrides, setResolutionOverrides] = useState({});

  if (!summaries || !Array.isArray(summaries)) {
    return <div>No summaries available</div>;
  }

  // xt 20260404 update to be readable now
  const agencyHasDepartments =
    !!agency?.details?.assignees?.departments?.length;

 const assignmentColumnEnabledForUser =
    profile?.details?.app_metadata?.assignment_column ?? false;

  const showAssignmentCol = assignmentColumnEnabledForUser;
  console.log("agencyHasDepartments =", agencyHasDepartments);
  console.log(
    "assignmentColumnEnabledForUser =",
    assignmentColumnEnabledForUser,
  );
  console.log("showAssignmentCol =", showAssignmentCol);

  const resolutionColumnEnabledForUser =
    profile?.details?.app_metadata?.resolution_column ?? false;

  const showResolutionCol = resolutionColumnEnabledForUser;

  const showPhotos = (incident) => {
    try {
      console.log('Dispatching showModal for INCIDENT_IMAGES with incident:',
        JSON.stringify(incident, null, 2),
      );
      dispatch(
        showModal('INCIDENT_IMAGES', {
          incident,
          images: incident.photos || [],
         }),
        );
    } catch (error) {
      console.error('Error in showPhotos:', error);
    }
  };

  const showMap = (incident) => {
    try {
      console.log('showMap called with incident:',
        JSON.stringify(incident, null, 2),
      );
      if (!dispatch || typeof dispatch !== 'function') {
        throw new Error('dispatch is not a function');
      }
      dispatch(showModal('INCIDENT_MAP', { incident }));
    } catch (error) {
      console.error('Error in showMap:', error);
    }
  };

  const getUnitAssignmentTime = (assignments) => {
    let assignmentTime;
    for (let assignment of assignments || []) {
      if (assignment?.assignee?.unit_id) {
        assignmentTime = assignment.received;
        break;
      }
    }
    return assignmentTime;
  };

  // Pagination logic
  const pageSizes = [10, 25, 50, 100];
  // const startIndex = curPage * rowPerPage;
  // const endIndex = Math.min(startIndex + rowPerPage, summaries.length);
  // const paginatedData = summaries.slice(startIndex, endIndex);
  const paginatedData = summaries;
  const computedTotalPages = totalPages; // aded by chatg

  // this from chatgo 6/28/25
  // Inside your component
  const [pageInput, setPageInput] = useState(curPage + 1); // local state for input
  // Sync input with actual page change
  useEffect(() => {
    setPageInput(curPage + 1);
  }, [curPage]);

  // now one set of jsx code
  return (
    <div>
      <div className="table-responsive ">
        <table className="table table-striped table-hover report-summaries-table">
          <thead>
            <tr>
              <th className="incident-column">Incident</th>
              <th className="description-column">Description</th>
              <th className="location-column">Location</th>
              <th className="reporter-column">Reporter Info</th>
              {showAssignmentCol && (
                <th className="responder-column">
                  Assignment
                </th>
              )}
              {showResolutionCol && (
                <th className="resolution-column">
                  Resolution
                </th>
              )}
              <th className="action-column">Actions & Status</th>
            </tr>
          </thead>
          <tbody>
            {/* this is where we convert from old react table to just B5 now we use row */}
            {paginatedData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td className="incident-column">
                  <div className="fix-whitespace">
                    <div className="summary-display text-medium text-color-red">
                      {row?.display_title || "N/A"}
                    </div>
                    <div className="summary-title text-primary-bsg text-medium">
                      {row?.title || "N/A"}
                    </div>
                    {row?.incident_type_translation?.en_US &&
                      row.title !== row.incident_type_translation.en_US && (
                        <div className="summary-title text-secondary text-medium rounded bg-light border p-1">
                          {row.incident_type_translation.en_US}
                        </div>
                      )}
                    <IncidentTimes
                      started={row?.started}
                      occurred={row?.occurred}
                      received={row?.received}
                      deptAssigned={
                        row?.assignments?.length > 0
                          ? row.assignments[0].received
                          : null
                      }
                      unitAssigned={getUnitAssignmentTime(row?.assignments)}
                    />
                    {(
                      resolutionOverrides[row?._id] ||
                      row?.resolved_incident_type ||
                      row?.resolution_summary?.resolved_incident_type
                    ) && (
                        <div
                          className="text-dark mt-1"
                          style={{ fontSize: "0.85rem", lineHeight: "1.1" }}
                        >
                          <span className="fw-bold">Resolved:</span>{" "}
                          <span>
                            {resolutionOverrides[row?._id] ||
                              row?.resolved_incident_type ||
                              row?.resolution_summary?.resolved_incident_type}
                          </span>
                        </div>
                      )}
                  </div>
                </td>
                <td className="description-column">
                  <div className="fix-whitespace text-medium">
                    <div className="text-primary-bsg">
                      {row?.description || "No description given"}
                    </div>
                    {row?.incident_description_translation?.en_US &&
                      row.description !==
                      row.incident_description_translation.en_US && (
                        <div className="text-secondary rounded bg-light border p-1">
                          {row.incident_description_translation.en_US}
                        </div>
                      )}
                    <div className="photo">
                      {row?.photos?.length > 0 && (
                        <a tabIndex="-1" onClick={() => showPhotos(row)}>
                          <i className="material-icons">photo_camera</i>
                          <span className="image-text text-medium">
                            {`${row.photos.length} Show Photo${row.photos.length > 1 ? "s" : ""}`}
                          </span>
                        </a>
                      )}
                      {(!row?.photos || row.photos.length === 0) && (
                        <span>
                          <i className="material-icons">no_photography</i>
                          <span className="image-text">No Photos</span>
                        </span>
                      )}
                    </div>
                  </div>
                </td>
                <td className="location-column">
                  <div className="fix-whitespace text-medium">
                    <div className="incident-location text-primary-bsg">
                      {row?.location || "N/A"}
                    </div>
                    {row?.location_description_translation?.en_US &&
                      row.location !==
                      row.location_description_translation.en_US && (
                        <div className="incident-location text-secondary text-medium rounded bg-light border p-1">
                          {row.location_description_translation.en_US}
                        </div>
                      )}
                    <div className="location">
                      {row?.coordinate && (
                        <a tabIndex="-1" onClick={() => showMap(row)}>
                          <i className="material-icons">location_on</i>
                          <span className="image-text text-medium">
                            Show Map
                          </span>
                        </a>
                      )}
                      <span className="image-text-gps">
                        <br />
                        gps:(
                        {row?.coordinate?.latitude != null &&
                          row?.coordinate?.longitude != null
                          ? `${row.coordinate.latitude}, ${row.coordinate.longitude}`
                          : "no lat"}
                        )
                      </span>
                      {!row?.coordinate && (
                        <span>
                          <i className="material-icons">location_off</i>
                          <span className="image-text">
                            No Map Coordinates Given
                          </span>
                        </span>
                      )}
                    </div>
                  </div>
                </td>
                <td className="reporter-column">
                  <div>
                    {row?.reporter_contact_allowed && (
                      <div className="fix-whitespace text-medium">
                        <div>{row?.reporter_name || "No name given"}</div>
                        <div>{row?.reporter_email || "No email given"}</div>
                        <div>
                          <NumericFormat
                            value={row?.reporter_phone || ""}
                            format="###-###-####"
                            displayType="text"
                          />
                        </div>
                      </div>
                    )}
                    {!row?.reporter_contact_allowed && (
                      <div>
                        <span className="badge bg-danger badge-sm">
                          Do Not Contact
                        </span>
                      </div>
                    )}
                    {row?.reporter_OS && (
                      <div className="fix-whitespace text-medium">
                        <div>
                          Phone OS: {row?.reporter_OS || "no OS detected"}
                        </div>
                        <div>
                          Phone Model:{" "}
                          {row?.reporter_phone_model ||
                            "no phone model detected"}
                        </div>
                      </div>
                    )}
                  </div>
                </td>
                {showAssignmentCol && (
                  <td className="responder-column">
                    <div>
                      {!agencyHasDepartments ? (
                        <span>No departments configured</span>
                      ) : (
                        row && (
                          <IncidentResponder
                            incident={row}
                            agency={agency?.details}
                            languageCode={languageCode}
                          />
                        )
                      )}
                    </div>
                  </td>
                )}
                {showResolutionCol && (
                  <td className="resolution-column">
                    <IncidentResolution
                      incident={row}
                      agency={agency}
                      reportSchemaId={row?.report_schema_id}
                      languageCode={languageCode}
                      profile={profile}
                      onResolutionSaved={(resolvedValue) => {
                        setResolutionOverrides((current) => ({
                          ...current,
                          [row?._id]: resolvedValue,
                        }));
                      }}
                    />
                  </td>
                )}
                <td className="action-column">
                  <div>
                    {row && (
                      <IncidentAction
                        incident={row}
                        agency={agency}
                        reportSchemaId={row?.report_schema_id}
                        languageCode={languageCode}
                        profile={profile}
                      />
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <nav
          aria-label="Report summaries pagination"
          className="d-flex align-items-center mt-3"
        >
          <ul className="pagination justify-content-center mb-0 flex-fill">
            {/* Previous */}
            <li className={`page-item ${curPage === 0 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => {
                  if (curPage > 0) {
                    updateCurPage(curPage - 1);
                  }
                }}
                disabled={curPage === 0}
                aria-disabled={curPage === 0}
                aria-label="Previous"
              >
                Previous
              </button>
            </li>

            {/* Page Number Input Page x of y */}
            <li className="page-item">
              <div className="d-flex align-items-center px-2">
                <span>Page</span>
                <input
                  type="number"
                  className="form-control form-control-sm mx-2"
                  style={{ width: "60px" }}
                  value={pageInput}
                  min="1"
                  max={computedTotalPages}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, ""); // optional: strip non-digits
                    +setPageInput(val);
                  }}
                  onBlur={() => {
                    const page = Number(pageInput);
                    if (
                      !isNaN(page) &&
                      page >= 1 &&
                      page <= computedTotalPages
                    ) {
                      +updateCurPage(page - 1);
                    } else {
                      setPageInput(curPage + 1); // reset to valid page
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.target.blur(); // trigger blur logic
                    }
                  }}
                  aria-label="Current page"
                />
                <span>of {computedTotalPages}</span>
              </div>
            </li>

            {/* Rows per page */}
            <li className="page-item">
              <div className="d-flex align-items-center px-2">
                <span>Rows per page:</span>
                <select
                  value={rowPerPage}
                  onChange={(e) => {
                    updateRowPerPage(Number(e.target.value));
                    updateCurPage(0);
                  }}
                  className="form-select form-select-sm ms-2"
                  style={{ width: "auto", minWidth: "100px" }}
                  aria-label="Rows per page"
                >
                  {pageSizes.map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
              </div>
            </li>

            {/* Next */}
            <li
              className={`page-item ${curPage >= totalPages - 1 ? "disabled" : ""}`}
            >
              <button
                className="page-link"
                onClick={() => {
                  if (curPage < totalPages - 1) {
                    updateCurPage(curPage + 1);
                  }
                }}
                disabled={curPage >= totalPages - 1}
                aria-disabled={curPage >= totalPages - 1}
                aria-label="Next"
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

ReportSummaries.propTypes = {
  summaries: PropTypes.array.isRequired,
  agency: PropTypes.object.isRequired,
  languageCode: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect()(ReportSummaries);
